import { render, staticRenderFns } from "./EditWhitelistDlg.vue?vue&type=template&id=1b3b64e5"
import script from "./EditWhitelistDlg.vue?vue&type=script&lang=js"
export * from "./EditWhitelistDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports